import AppHeader from '../../views/AppHeader.vue';
export default [
  {
    path: '/app-header',
    name: 'AppHeader',
    component: AppHeader
  }
];